export default __webpack_public_path__ + "static/media/1(4).8d4ee1e0.jpg";